import ContentCopy from '@mui/icons-material/ContentCopy';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Alert, AlertTitle, Button, Collapse, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { clipboard } from '../../utils/clipboard';
import { useStyles } from './styles';

interface ApiErrorAlertProps {
  title: string;
  description?: string;
  technicalDetails: string;
  severity?: 'error' | 'warning';
  onClose?: () => void;
}

export const ApiErrorAlert: FC<ApiErrorAlertProps> = ({
  title,
  description,
  technicalDetails,
  severity = 'error',
  onClose,
}) => {
  const classes = useStyles();
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) {
      return;
    }
    const timeoutId = window.setTimeout(() => setCopied(false), 2000);
    return () => window.clearTimeout(timeoutId);
  }, [copied]);

  return (
    <Alert severity={severity} onClose={onClose} data-cy="api-error-alert">
      <AlertTitle>{title}</AlertTitle>
      {description && <Typography variant="body2">{description}</Typography>}
      {technicalDetails && (
        <>
          <div className={classes.detailsHeader}>
            <Button
              type="button"
              size="small"
              className={classes.detailsToggle}
              startIcon={detailsOpen ? <ExpandLess /> : <ExpandMore />}
              onClick={() => setDetailsOpen((open) => !open)}
            >
              Détails techniques
            </Button>
            <Button
              type="button"
              size="small"
              className={classes.copyButton}
              startIcon={<ContentCopy fontSize="small" />}
              onClick={() => {
                clipboard(technicalDetails);
                setCopied(true);
              }}
            >
              {copied ? 'Copié' : 'Copier'}
            </Button>
          </div>
          <Collapse in={detailsOpen}>
            <pre className={classes.technicalDetails}>{technicalDetails}</pre>
          </Collapse>
        </>
      )}
    </Alert>
  );
};
